import {
  QUICKSCAN_TAG_NAME,
  registerCustomElement,
} from './web-component'

const ANCHOR_SELECTOR = '[data-wtta-quickscan]'
const HYDRATED_FLAG = 'wttaQuickscanHydrated'

const ATTRIBUTE_MAP: Record<string, string> = {
  'data-pardot-form-url': 'pardot-form-url',
  'data-pardot-account-id': 'pardot-account-id',
  'data-pardot-form-id': 'pardot-form-id',
  'data-pardot-form-host': 'pardot-form-host',
  'data-report-page-url': 'report-page-url',
}

function hydrateAnchor(anchor: HTMLElement): void {
  const dataset = anchor.dataset as DOMStringMap & { [HYDRATED_FLAG]?: string }
  if (dataset[HYDRATED_FLAG] === 'true') return
  dataset[HYDRATED_FLAG] = 'true'

  const widget = document.createElement(QUICKSCAN_TAG_NAME)
  if (anchor.id) {
    widget.id = anchor.id
  }
  for (const [datasetKey, attrName] of Object.entries(ATTRIBUTE_MAP)) {
    const value = anchor.getAttribute(datasetKey)
    if (value) {
      widget.setAttribute(attrName, value)
    }
  }

  anchor.appendChild(widget)
}

function hydrateAll(): void {
  const anchors = document.querySelectorAll<HTMLElement>(ANCHOR_SELECTOR)
  anchors.forEach(hydrateAnchor)
}

function init(): void {
  registerCustomElement()

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateAll, { once: true })
  } else {
    hydrateAll()
  }

  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return
          if (node.matches?.(ANCHOR_SELECTOR)) {
            hydrateAnchor(node)
          }
          node.querySelectorAll?.<HTMLElement>(ANCHOR_SELECTOR).forEach(hydrateAnchor)
        })
      }
    })
    observer.observe(document.body, { childList: true, subtree: true })
  }
}

init()

export { hydrateAll, registerCustomElement }
